import React, { useState } from 'react'
import MediaQuery from 'react-responsive'
import { MenuOutlined } from '@ant-design/icons'
import { Drawer, Divider } from 'antd'
import { getRooms, getRoom } from '../../utils/helpers'

const imgs = require.context('../../assets/img', true)

const Menu = () => {
  const [showDrawer, setShowDrawer] = useState(false)
  const [hoverItem, setHoverItem] = useState(null)
  const rooms = getRooms()

  return (
    <MediaQuery minDeviceWidth={1000}>
      {(matches) =>
        matches ? (
          <div className="menu">
            {rooms.map((id) => {
              const room = getRoom(id)
              return (
                <a
                  key={id}
                  href={'#' + id}
                  onMouseOver={() => setHoverItem(id)}
                  onMouseLeave={() => setHoverItem(null)}>
                  <div className={hoverItem === id ? 'hover-item' : 'item'}>
                    <img src={imgs('./' + room.img)} alt="N/A"></img>
                    {hoverItem === id && <span>{room.name}</span>}
                  </div>
                </a>
              )
            })}
          </div>
        ) : (
          <>
            <div className="mobile-menu">
              <div className="mobile-header">
                <h1>Stardew Valley</h1>
                <h5>Bundle Tracker</h5>
              </div>
              <MenuOutlined onClick={() => setShowDrawer(true)} />
            </div>
            <Drawer
              placement="right"
              closable={true}
              onClose={() => setShowDrawer(false)}
              visible={showDrawer}>
              <div className="menu-drawer">
                <Divider style={{ marginBottom: '30px' }}>Rooms</Divider>
                {rooms.map((id) => {
                  const room = getRoom(id)
                  return (
                    <a
                      key={id}
                      href={'#' + id}
                      onClick={() => setShowDrawer(false)}>
                      <img src={imgs('./' + room.img)} alt="N/A"></img>
                      <span>{room.name}</span>
                    </a>
                  )
                })}
              </div>
            </Drawer>
          </>
        )
      }
    </MediaQuery>
  )
}

export default Menu
